import { getPixelsPerMeter } from "../structurePlacementFunction/smithStructure";

export function calculateDistance(point1, point2, roofInfo, gridInfo) {
  let pixelMultiple = getPixelsPerMeter(roofInfo);
  let distance =
    (Math.sqrt(
      Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2)
    ) *
      3.28084) /
    pixelMultiple;

  const scaleParameter = gridInfo.unit;

  if (scaleParameter === "m") {
    distance = (distance / 3.28084).toFixed(1);
    return `${distance}m`;
  } else {
    distance = distance.toFixed(1);
    return `${distance}ft`;
  }
}

export function xPlacement(point1, point2, Points) {
  let index, adjustedPoints;

  if (Points && Points.length > 1) {
    adjustedPoints = Points.flatMap((point) => [point.x, point.y]);
    index = adjustedPoints.indexOf(point1.x);
  }
  let lineMidpointY = (point2.x + point1.x) / 2;

  // // Check relative position
  if (index === 0) {
    if (point1.x >= point2.x) {
      if (point1.y >= point2.y) {
        lineMidpointY -= 5;
      } else {
        lineMidpointY += 10;
      }
    } else {
      if (point1.y >= point2.y) {
        lineMidpointY -= 15;
      } else {
        lineMidpointY += 15;
      }
    }
  } else if (index === adjustedPoints.length - 2) {
    if (point1.x >= point2.x) {
      if (point1.y >= point2.y) {
        lineMidpointY -= 5;
      } else {
        lineMidpointY += 10;
      }
    } else {
      if (point1.y >= point2.y) {
        lineMidpointY -= 15;
      } else {
        lineMidpointY += 15;
      }
    }
  } else {
    if (point1.x > adjustedPoints[index - 2]) {
      if (point1.x >= point2.x) {
        if (point1.y >= point2.y) {
          lineMidpointY -= 5;
        } else {
          lineMidpointY += 10;
        }
      } else {
        if (point1.y >= point2.y) {
          lineMidpointY -= 15;
        } else {
          lineMidpointY += 15;
        }
      }
    } else {
      if (point1.x >= point2.x) {
        if (point1.y >= point2.y) {
          lineMidpointY += 15;
        } else {
          lineMidpointY -= 15;
        }
      } else {
        if (point1.y > point2.y) {
          lineMidpointY -= 15;
        } else {
          lineMidpointY -= 5;
        }
      }
    }
  }

  return lineMidpointY;
}

export function yCursorPlacement(point1, point2) {
  const slope = (point2.y - point1.y) / (point2.x - point1.x);

  var value = (point2.y + point1.y) / 2;
  if (slope >= 0) {
    value += 3;
  }
  return value;
}

export function yPlacement(point1, point2, Points) {
  let index, adjustedPoints;

  if (Points && Points.length > 1) {
    adjustedPoints = Points.flatMap((point) => [point.x, point.y]);
    index = adjustedPoints.indexOf(point1.x);
  }
  let lineMidpointY = (point2.y - 5 + (point1.y - 5)) / 2;

  // Check relative position
  if (index === 0) {
    if (point1.x >= point2.x) {
      if (point1.y > point2.y) {
        lineMidpointY += point1.y - point2.y > 10 ? 5 : 10;
      } else {
        lineMidpointY += point2.y - point1.y > 10 ? 5 : 10;
      }
    } else {
      if (point1.y > point2.y) {
        lineMidpointY -= point1.y - point2.y > 10 ? 10 : 15;
      } else {
        lineMidpointY -= point2.y - point1.y > 10 ? 5 : 10;
      }
    }
  } else if (index === adjustedPoints.length - 2) {
    if (point1.x >= point2.x) {
      if (point1.y >= point2.y) {
        lineMidpointY += point1.y - point2.y > 10 ? 5 : 10;
      } else {
        lineMidpointY += point2.y - point1.y > 10 ? 5 : 10;
      }
    } else {
      if (point1.y >= point2.y) {
        lineMidpointY -= point1.y - point2.y > 10 ? 10 : 15;
      } else {
        lineMidpointY -= point2.y - point1.y > 10 ? 5 : 10;
      }
    }
  } else {
    if (point1.x > adjustedPoints[index - 2]) {
      if (point1.x >= point2.x) {
        if (point1.y >= point2.y) {
          lineMidpointY += point1.y - point2.y > 10 ? 5 : 10;
        } else {
          lineMidpointY += point2.y - point1.y > 10 ? 5 : 10;
        }
      } else {
        if (point1.y >= point2.y) {
          lineMidpointY -= point1.y - point2.y > 10 ? 10 : 15;
        } else {
          lineMidpointY -= point2.y - point1.y > 10 ? 5 : 10;
        }
      }
    } else {
      if (point1.x >= point2.x) {
        if (point1.y >= point2.y) {
          lineMidpointY -= point1.y - point2.y > 15 ? 5 : 10;
        } else {
          lineMidpointY -= point2.y - point1.y > 15 ? 5 : 10;
        }
      } else {
        if (point1.y >= point2.y) {
          lineMidpointY -= point1.y - point2.y > 15 ? 5 : 10;
        } else {
          lineMidpointY += point2.y - point1.y > 15 ? 5 : 10;
        }
      }
    }
  }

  return lineMidpointY;
}

export function rotation(point1, point2) {
  const slope = (point2.y - point1.y) / (point2.x - point1.x);
  const angleInRadians = Math.atan(slope);
  var angleInDegrees = (angleInRadians * 180) / Math.PI;

  return angleInDegrees;
}

export const xPoint = (points) => {
  const adjustedPoints = points.flatMap((point) => [point.x + 0, point.y + 0]);
  const maxY = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 1));
  const indexvalue = adjustedPoints.indexOf(maxY);
  let x = adjustedPoints[indexvalue - 1];

  return x;
};

export const yPoint = (points) => {
  const adjustedPoints = points.flatMap((point) => [point.x + 0, point.y + 0]);
  const maxY = Math.min(...adjustedPoints.filter((_, i) => i % 2 === 1));

  return maxY;
};
